

// Beanie Builder JS
// - Step geçişleri, seçilen ürünleri sepete yazma
// - Patch overlay pozisyon ayarı (bere başlığına göre tuning)
// - Upload / Text design oluşturma + oklarla sağa/sola/yukarı/aşağı kaydırma + zoom
// - Cloudinary upload + cart/add.js ile sepete ekleme
// Not: moneyFormat artık Liquid’den gelmez, window.BEANIE_BUILDER_DATA.moneyFormat üzerinden gelir

window.BB_BUILDER_CONFIG = {
  // Tasarım blob'unu Cloudinary'ye yüklemek için config
  cloudinary: { cloudName: "dzhsc9xxt", uploadPreset: "bb_unsigned" }
};

// Tasarım blob'unu Cloudinary'ye upload eder, URL döner
window.uploadToCloudinary = async function uploadToCloudinary(blob){
  const cfg = window.BB_BUILDER_CONFIG?.cloudinary;
  if(!cfg?.cloudName || !cfg?.uploadPreset) throw new Error("Cloudinary config missing.");
  const form = new FormData();
  form.append("file", blob, "print.png");
  form.append("upload_preset", cfg.uploadPreset);
  const endpoint = `https://api.cloudinary.com/v1_1/${cfg.cloudName}/image/upload`;
  const res = await fetch(endpoint,{ method:"POST", body:form });
  if(!res.ok){
    const txt = await res.text().catch(()=> "");
    throw new Error("Cloudinary upload failed: " + txt);
  }
  const data = await res.json();
  return data.secure_url || data.url;
};
(()=>{

    if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }
  window.addEventListener("pageshow", () => {
    window.scrollTo(0, 0);
  });

  // Builder root elementini bulur, yoksa çalışmaz
  const root = document.getElementById("bp-builder");
  if(!root) return;

  const STORAGE_KEY="bb_builder_selection_v1";
  const DESIGN_PRODUCT_HANDLE="design-your-patch";
const PATCH_FRAME_URL = "https://cdn.shopify.com/s/files/1/0632/5108/7423/files/ChatGPT_Image_Feb_9_2026_05_16_08_PM.png?v=1770657398";
  // Text patch base görselleri: seçilen patch color’a göre base değişir
  const TEXT_PATCH_BASES = {
    black: "https://cdn.shopify.com/s/files/1/0632/5108/7423/files/ChatGPT_Image_Feb_17_2026_01_50_07_PM.png?v=1771337015",
    white: "https://cdn.shopify.com/s/files/1/0632/5108/7423/files/ChatGPT_Image_Feb_10_2026_02_12_27_PM.png?v=1770732900",
    brown: "https://cdn.shopify.com/s/files/1/0632/5108/7423/files/ChatGPT_Image_Feb_17_2026_02_07_25_PM.png?v=1771337257"
  };

  // Seçimler ve tasarım state’i (localStorage ile saklanır)
const state={
  step:1,
  beanie:null,
  patch:null,
  design:null,
  oldPatch:null,

  // ✅ Add Text: sadece base seçimi (yazı yokken bile basket’te görünsün)
  textBase:null,

  designVariantId:0,
  designPriceCents:900,
  textPatchColor:"black"
};

  // Shopify moneyFormat (Liquid -> window üzerinden geliyor)
  const moneyFormat = (window.BEANIE_BUILDER_DATA && window.BEANIE_BUILDER_DATA.moneyFormat) ? window.BEANIE_BUILDER_DATA.moneyFormat : "${{amount}}";
  const hasShopifyMoney = window.Shopify && typeof window.Shopify.formatMoney==="function";

  function formatMoney(cents){
    const c=Number(cents||0);
    return hasShopifyMoney ? window.Shopify.formatMoney(c,moneyFormat) : "£"+(c/100).toFixed(2);
  }
  function escapeHtml(str){
    return String(str||"")
      .replaceAll("&","&amp;")
      .replaceAll("<","&lt;")
      .replaceAll(">","&gt;")
      .replaceAll('"',"&quot;")
      .replaceAll("'","&#039;");
  }
  function isMobile(){ return window.matchMedia && window.matchMedia("(max-width: 980px)").matches; }
  function clamp(n,min,max){ return Math.max(min,Math.min(max,n)); }

  const panels=root.querySelectorAll(".bp-panel");
  const steps=root.querySelectorAll(".bp-step");
  const countBeanie=root.querySelector('[data-count="beanie"]');
  const countPatch=root.querySelector('[data-count="patch"]');
  const countDesign=root.querySelector('[data-count="design"]');

  const pickedBeanie=root.querySelector('[data-picked="beanie"]');
  const pickedPatch=root.querySelector('[data-picked="patch"]');
  const patchLabelEl=root.querySelector("[data-patch-label]");

  const addBtn=root.querySelector(".bp-add");
  const noteEl=root.querySelector("[data-note]");
  const basketEl=root.querySelector("[data-basket]");
  const patchCategorySelect=root.querySelector("[data-patch-category]");

  const designFileInput=root.querySelector("[data-design-file]");
  const designUploadBtn=root.querySelector("[data-design-upload]");
  const designImgEl=root.querySelector("[data-design-img]");
  const designPlaceholderEl=root.querySelector("[data-design-placeholder]");
  const designRemoveBtn=root.querySelector("[data-design-remove]");
  const designBackOldBtn=root.querySelector("[data-design-backold]");
  const designMaskEl=root.querySelector("[data-design-mask]");
  const controlsEl=root.querySelector("[data-design-controls]");
  const zoomRangeEl=root.querySelector("[data-zoom-range]");

  const textBtn=root.querySelector("[data-design-text]");
  const textPanel=root.querySelector("[data-text-panel]");
  const textInput=root.querySelector("[data-text-input]");
  const textSize=root.querySelector("[data-text-size]");
  const textColor=root.querySelector("[data-text-color]");
  const textFont=root.querySelector("[data-text-font]");
  const textLetter=root.querySelector("[data-text-letter]");
  const textLine=root.querySelector("[data-text-line]");
  const textStrokeToggle=root.querySelector("[data-tstroke]");
  const textStrokeWidth=root.querySelector("[data-text-stroke]");
  const textUpperToggle=root.querySelector("[data-tupper]");
  const textShadowToggle=root.querySelector("[data-tshadow]");
  const textCancel=root.querySelector("[data-text-cancel]");
  const textBoldBtn=root.querySelector("[data-tbold]");
  const textItalicBtn=root.querySelector("[data-titalic]");
  const textAlignBtns=root.querySelectorAll("[data-talign]");
  const patchBaseEl=root.querySelector("[data-patch-base]");
  const patchColorBtns=root.querySelectorAll("[data-patch-color]");

  const modalEl=document.querySelector("[data-bp-modal]");
  const modalPreviewEl=document.querySelector("[data-bp-modal-preview]");

  function note(msg,show){
    if(!noteEl) return;
    noteEl.style.display=show?"block":"none";
    noteEl.textContent=msg||"";
  }
  function scrollToTop(){ window.scrollTo({ top: 0, behavior: "auto" }); }
  const BASKET_SCROLL_OFFSET=220;
  function scrollToBasketWithOffset(){
    if(!basketEl) return;
    const y=basketEl.getBoundingClientRect().top+window.pageYOffset-BASKET_SCROLL_OFFSET;
    window.scrollTo({top:Math.max(0,y),behavior:"smooth"});
  }

  // Bere başlığındaki renge göre patch overlay pozisyonunu değiştirir
  const TUNING_BY_COLOR=[
    {key:"mustard",m:{w:"24%",x:"50%",y:"65%"},d:{w:"24%",x:"50%",y:"65%"}},
    {key:"black",m:{w:"26%",x:"51%",y:"65%"},d:{w:"26%",x:"51%",y:"65%"}},
    {key:"khaki",m:{w:"26%",x:"52%",y:"72%"},d:{w:"26%",x:"52%",y:"72%"}},
    {key:"orange",m:{w:"26%",x:"53%",y:"73%"},d:{w:"26%",x:"53%",y:"73%"}},
    {key:"grey",m:{w:"26%",x:"51%",y:"63%"},d:{w:"26%",x:"51%",y:"63%"}},
    {key:"pink",m:{w:"26%",x:"51%",y:"65%"},d:{w:"26%",x:"51%",y:"65%"}},
    {key:"navy blue",m:{w:"26%",x:"51%",y:"67%"},d:{w:"26%",x:"51%",y:"67%"}},
    {key:"yellow",m:{w:"25%",x:"50%",y:"67%"},d:{w:"25%",x:"50%",y:"67%"}},
    {key:"white",m:{w:"24%",x:"50%",y:"69%"},d:{w:"24%",x:"50%",y:"69%"}},
    {key:"blue",m:{w:"26%",x:"51%",y:"65%"},d:{w:"26%",x:"51%",y:"65%"}},
    {key:"red",m:{w:"26%",x:"51%",y:"66%"},d:{w:"26%",x:"51%",y:"66%"}}
  ];
  function applyTuningForBeanieTitle(title){
    const t=(title||"").toLowerCase();
    const hit=TUNING_BY_COLOR.find(r=>t.includes(String(r.key||"").toLowerCase()));
    if(!hit) return;
    const r=document.documentElement.style;
    if(isMobile()){
      r.setProperty("--patch-w-m",hit.m.w);
      r.setProperty("--patch-x-m",hit.m.x);
      r.setProperty("--patch-y-m",hit.m.y);
      r.setProperty("--patch-w-big-m",hit.m.w);
      r.setProperty("--patch-x-big-m",hit.m.x);
      r.setProperty("--patch-y-big-m",hit.m.y);
    }else{
      r.setProperty("--patch-w-d",hit.d.w);
      r.setProperty("--patch-x-d",hit.d.x);
      r.setProperty("--patch-y-d",hit.d.y);
      r.setProperty("--patch-w-big",hit.d.w);
      r.setProperty("--patch-x-big",hit.d.x);
      r.setProperty("--patch-y-big",hit.d.y);
    }
  }

  const MOVE_STEP=6, ZOOM_STEP=.08, ZOOM_MIN=1, ZOOM_MAX=3;

  // Tasarımın sağa/sola/yukarı/aşağı kaydırma + zoom değerlerini hazırlar
  function ensureTransform(){
    if(!state.design) return;
    if(!state.design.transform) state.design.transform={x:0,y:0,scale:1.15};
    else{
      if(typeof state.design.transform.x!=="number") state.design.transform.x=0;
      if(typeof state.design.transform.y!=="number") state.design.transform.y=0;
      if(typeof state.design.transform.scale!=="number") state.design.transform.scale=1.15;
      state.design.transform.scale=clamp(state.design.transform.scale,ZOOM_MIN,ZOOM_MAX);
    }
    if(zoomRangeEl) zoomRangeEl.value=String(state.design.transform.scale);
  }
  function applyTransformToImage(){
  if(!designImgEl) return;
  if(!(state.design&&state.design.image)) return;
  ensureTransform();
  const t=state.design.transform;
  designImgEl.style.transform=`translate(${t.x}px, ${t.y}px) scale(${t.scale})`;
}
// ✅ MOBILE + TEXT MODE: drag + pinch zoom gesture
(function initTextGestures(){
  if(!designMaskEl) return;

  let pointers = new Map(); // pointerId -> {x,y}
  let start = null;         // başlangıç state snapshot
  let raf = 0;

  const dist = (a,b) => Math.hypot(a.x-b.x, a.y-b.y);
  const mid  = (a,b) => ({ x:(a.x+b.x)/2, y:(a.y+b.y)/2 });

  function isTextGestureActive(){
    return isMobile() && state.design && state.design.image && state.design.type === "text";
  }

  function getPoint(e){
    return { x: e.clientX, y: e.clientY };
  }

  function snapshotStart(){
    ensureTransform();
    start = {
      x: state.design.transform.x,
      y: state.design.transform.y,
      s: state.design.transform.scale,
      // pinch için
      p1: null,
      p2: null,
      d0: 0,
      m0: null
    };
  }

  function scheduleApply(){
    if(raf) return;
    raf = requestAnimationFrame(()=>{
      raf = 0;
      applyTransformToImage();
      refreshPreviewSoon();
      saveState();
    });
  }

  designMaskEl.addEventListener("pointerdown", (e)=>{
    if(!isTextGestureActive()) return;
    // text mode değilse hiç karışma
    designMaskEl.setPointerCapture?.(e.pointerId);

    pointers.set(e.pointerId, getPoint(e));

    // ilk dokunuşta start al
    if(pointers.size === 1){
      snapshotStart();
      start.p1 = getPoint(e);
    }

    // ikinci dokunuş geldiyse pinch başlangıcını al
    if(pointers.size === 2){
      const pts = Array.from(pointers.values());
      start.p1 = pts[0];
      start.p2 = pts[1];
      start.d0 = dist(start.p1, start.p2) || 1;
      start.m0 = mid(start.p1, start.p2);
    }

    e.preventDefault();
  }, { passive:false });

  designMaskEl.addEventListener("pointermove", (e)=>{
    if(!isTextGestureActive()) return;
    if(!pointers.has(e.pointerId)) return;

    pointers.set(e.pointerId, getPoint(e));
    if(!start) snapshotStart();

    // 1 parmak: drag
    if(pointers.size === 1){
      const p = Array.from(pointers.values())[0];
      const dx = p.x - start.p1.x;
      const dy = p.y - start.p1.y;

      state.design.transform.x = start.x + dx;
      state.design.transform.y = start.y + dy;
      scheduleApply();
      e.preventDefault();
      return;
    }

    // 2 parmak: pinch + pan (midpoint ile)
    if(pointers.size >= 2){
      const pts = Array.from(pointers.values()).slice(0,2);
      const d1 = dist(pts[0], pts[1]) || 1;
      const m1 = mid(pts[0], pts[1]);

      const scaleFactor = d1 / (start.d0 || 1);
      const newScale = clamp(start.s * scaleFactor, ZOOM_MIN, ZOOM_MAX);

      // midpoint hareketiyle pan
      const mdx = m1.x - (start.m0?.x || m1.x);
      const mdy = m1.y - (start.m0?.y || m1.y);

      state.design.transform.scale = newScale;
      state.design.transform.x = start.x + mdx;
      state.design.transform.y = start.y + mdy;

      if(zoomRangeEl) zoomRangeEl.value = String(state.design.transform.scale);

      scheduleApply();
      e.preventDefault();
    }
  }, { passive:false });

  function endPointer(e){
    if(!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);

    // 2 parmaktan 1 parmağa düşerse start’ı yeniden al (zıplamasın)
    if(pointers.size === 1 && isTextGestureActive()){
      snapshotStart();
      start.p1 = Array.from(pointers.values())[0];
    }

    if(pointers.size === 0){
      start = null;
    }
  }

  designMaskEl.addEventListener("pointerup", endPointer);
  designMaskEl.addEventListener("pointercancel", endPointer);
  designMaskEl.addEventListener("pointerleave", endPointer);
})();
function showControls(show){ if(controlsEl) controlsEl.style.display=show?"":"none"; }

  // Kare clip path (radius 0)
  function roundedRectPath(ctx,x,y,w,h,r){
    const rr=Math.max(0,Math.min(r,Math.min(w,h)/2));
    ctx.beginPath();
    ctx.moveTo(x+rr,y);
    ctx.arcTo(x+w,y,x+w,y+h,rr);
    ctx.arcTo(x+w,y+h,x,y+h,rr);
    ctx.arcTo(x,y+h,x,y,rr);
    ctx.arcTo(x,y,x+w,y,rr);
    ctx.closePath();
  }
  function getMaskRadiusPx(){
    try{
      const el = root.querySelector("[data-design-mask]");
      if(!el) return 0;
      const r = window.getComputedStyle(el).borderTopLeftRadius || "0";
      const n = parseFloat(r);
      return Number.isFinite(n) ? n : 0;
    }catch(e){
      return 0;
    }
  }
  // Mask’li preview üretir (sepette ve modalda düzgün görünmesi için)
  async function makeMaskedPreviewDataUrl(scale=2, includeBase=true){
    if(!(state.design&&state.design.image&&state.design.transform)) return "";
    const baseW=Number(state.design.transform.baseW||240);
    const baseH=Number(state.design.transform.baseH||240);
    const cw=Math.max(1,Math.round(baseW*scale));
    const ch=Math.max(1,Math.round(baseH*scale));

    const srcImg=await new Promise((resolve,reject)=>{
      const im=new Image();
      im.onload=()=>resolve(im);
      im.onerror=reject;
      im.src=state.design.image;
    });

    const baseUrl = state.design.patchBaseUrl || "";
    const baseImg = baseUrl ? await new Promise((resolve)=>{
      const im=new Image();
      im.crossOrigin="anonymous";
      im.onload=()=>resolve(im);
      im.onerror=()=>resolve(null);
      im.src=baseUrl;
    }) : null;

    function computeContain(maskW,maskH,imgW,imgH){
      const imgAR=imgW/imgH;
      const maskAR=maskW/maskH;
      if(imgAR>=maskAR){
        const fitW=maskW;
        const fitH=maskW/imgAR;
        return{fitW,fitH};
      }else{
        const fitH=maskH;
        const fitW=maskH*imgAR;
        return{fitW,fitH};
      }
    }

    const {fitW,fitH}=computeContain(baseW,baseH,srcImg.naturalWidth||srcImg.width,srcImg.naturalHeight||srcImg.height);
    const s=Number(state.design.transform.scale||1.15);
    const tx=Number(state.design.transform.x||0);
    const ty=Number(state.design.transform.y||0);

    const drawW=fitW*s;
    const drawH=fitH*s;
    const cx=baseW/2+tx;
    const cy=baseH/2+ty;

    const canvas=document.createElement("canvas");
    canvas.width=cw; canvas.height=ch;
    const ctx=canvas.getContext("2d");
    ctx.clearRect(0,0,cw,ch);

    ctx.save();
        const rCanvas = getMaskRadiusPx() * scale;
    roundedRectPath(ctx,0,0,cw,ch,rCanvas);
    ctx.clip();

    ctx.scale(scale,scale);
    ctx.drawImage(srcImg,cx-drawW/2,cy-drawH/2,drawW,drawH);
    ctx.restore();

    if(includeBase && baseImg){
  ctx.drawImage(baseImg,0,0,cw,ch);
}

    return canvas.toDataURL("image/png");
  }
  async function buildAndSetDesignPreview(){
  if(!(state.design && state.design.image)) return;

  try{
    const url = await makeMaskedPreviewDataUrl(2, false);
    if(state.design){
      state.design.preview = url;
    }
  }catch(e){
    console.warn("Preview generation failed", e);
  }
}

  let previewTimer=null;
  function refreshPreviewSoon(){
    if(!state.design) return;
    if(previewTimer) window.clearTimeout(previewTimer);
    previewTimer=window.setTimeout(async()=>{
      try{
        const url = await makeMaskedPreviewDataUrl(2, false);
        if(state.design) state.design.preview=url;
        update();
        saveState();
      }catch(e){}
    },80);
  }

  // Final baskı PNG blob (sadece tasarım, base yok)
  async function generateFinalPrintPngBlob(){
    if(!(state.design&&state.design.image&&state.design.transform)) throw new Error("No design selected");

    const baseW=Number(state.design.transform.baseW||240);
    const baseH=Number(state.design.transform.baseH||240);
    const SCALE=4;
    const cw=Math.max(1,Math.round(baseW*SCALE));
    const ch=Math.max(1,Math.round(baseH*SCALE));

    const srcImg=await new Promise((resolve,reject)=>{
      const im=new Image();
      im.onload=()=>resolve(im);
      im.onerror=reject;
      im.src=state.design.image;
    });

    function computeContain(maskW,maskH,imgW,imgH){
      const imgAR=imgW/imgH;
      const maskAR=maskW/maskH;
      if(imgAR>=maskAR){
        const fitW=maskW;
        const fitH=maskW/imgAR;
        return{fitW,fitH};
      }else{
        const fitH=maskH;
        const fitW=maskH*imgAR;
        return{fitW,fitH};
      }
    }

    const {fitW,fitH}=computeContain(baseW,baseH,srcImg.naturalWidth||srcImg.width,srcImg.naturalHeight||srcImg.height);
    const s=Number(state.design.transform.scale||1.15);
    const tx=Number(state.design.transform.x||0);
    const ty=Number(state.design.transform.y||0);

    const drawW=fitW*s;
    const drawH=fitH*s;
    const cx=baseW/2+tx;
    const cy=baseH/2+ty;

    const canvas=document.createElement("canvas");
    canvas.width=cw; canvas.height=ch;
    const ctx=canvas.getContext("2d");
    ctx.clearRect(0,0,cw,ch);

       ctx.save();

    const rCanvas = getMaskRadiusPx() * SCALE;
    roundedRectPath(ctx,0,0,cw,ch,rCanvas);
    ctx.clip();

    ctx.scale(SCALE,SCALE);
    ctx.drawImage(srcImg,cx-drawW/2,cy-drawH/2,drawW,drawH);
    ctx.restore();

    return new Promise((resolve,reject)=>{
      canvas.toBlob(blob=>{
        if(!blob) return reject(new Error("Blob export failed"));
        resolve(blob);
      },"image/png",1);
    });
  }

  // Text render ayarları
  const textUi={ bold:false, italic:false, align:"center", upper:false, stroke:false, shadow:false };

  function setAlignUI(a){
    textUi.align=a;
    textAlignBtns.forEach(b=>b.classList.toggle("is-active",b.getAttribute("data-talign")===a));
  }

  function drawTextWithLetterSpacing(ctx, text, x, y, align, letterPx){
    const s=String(text||"");
    if(!letterPx){
      ctx.textAlign=align;
      ctx.fillText(s,x,y);
      return;
    }
    const chars=[...s];
    const widths=chars.map(ch=>ctx.measureText(ch).width);
    const total = widths.reduce((a,b)=>a+b,0) + letterPx*(chars.length-1);
    let startX = x;
    if(align==="center") startX = x - total/2;
    if(align==="right") startX = x - total;
    let cx=startX;
    for(let i=0;i<chars.length;i++){
      ctx.textAlign="left";
      ctx.fillText(chars[i],cx,y);
      cx += widths[i] + letterPx;
    }
  }

  function wrapTextToLines(ctx, text, maxWidth){
    const raw=String(text||"").replace(/\r/g,"");
    const paragraphs=raw.split("\n");
    const lines=[];
    for(const p of paragraphs){
      const words=p.split(" ");
      let line="";
      for(const w of words){
        const test=(line?line+" ":"")+w;
        const mw=ctx.measureText(test).width;
        if(mw>maxWidth && line){
          lines.push(line);
          line=w;
        }else{
          line=test;
        }
      }
      lines.push(line);
    }
    return lines;
  }

  // Text’i PNG dataURL olarak üretir (sonra design.image olur)
  function makeTextImageDataUrl(props){
    const w=900,h=900;
    const c=document.createElement("canvas");
    c.width=w; c.height=h;
    const ctx=c.getContext("2d");
    ctx.clearRect(0,0,w,h);

    const text=(props.upper?String(props.text||"").toUpperCase():String(props.text||""));
    const size=Number(props.size||48);
    const color=props.color||"#111111";
    const bold=!!props.bold;
    const italic=!!props.italic;
    const align=props.align||"center";
    const family=props.font||"Arial";
    const letter=Number(props.letter||0);
    const lineMult=Number(props.line||1.15);
    const strokeOn=!!props.stroke;
    const strokeW=Number(props.strokeW||3);
    const shadowOn=!!props.shadow;

    ctx.font=`${italic?"italic ":""}${bold?"800 ":"700 "}${size}px ${family}`;
    ctx.fillStyle=color;
    ctx.textBaseline="middle";

    if(shadowOn){
      ctx.shadowColor="rgba(0,0,0,0.25)";
      ctx.shadowBlur=8;
      ctx.shadowOffsetX=0;
      ctx.shadowOffsetY=2;
    }else{
      ctx.shadowColor="transparent";
      ctx.shadowBlur=0;
      ctx.shadowOffsetX=0;
      ctx.shadowOffsetY=0;
    }

    const padding=80;
    const maxWidth=w-padding*2;

    const lines=wrapTextToLines(ctx,text,maxWidth);
    const lineHeight=Math.round(size*lineMult);

    const totalH = lines.length * lineHeight;
    let startY = (h/2) - (totalH/2) + (lineHeight/2);

    let x = w/2;
    if(align==="left") x=padding;
    if(align==="right") x=w-padding;

    if(strokeOn){
      ctx.lineJoin="round";
      ctx.miterLimit=2;
      ctx.strokeStyle="rgba(0,0,0,0.85)";
      ctx.lineWidth=strokeW;
    }

    for(let i=0;i<lines.length;i++){
      const y = startY + i*lineHeight;

      if(strokeOn){
        ctx.textAlign=align;
        ctx.strokeText(lines[i],x,y);
      }

      drawTextWithLetterSpacing(ctx,lines[i],x,y,align,letter);
    }

    return c.toDataURL("image/png");
  }

  // Step değiştirir (panel göster/gizle)
  function setStep(n){
    if((n===2||n===3)&&!state.beanie){
      note("Please select a beanie first.",true);
      n=1;
    }else{
      note("",false);
    }
        // ✅ Step 2'ye dönünce Add Text modunu zorla kapat (hazır patch patlamasın)
    if(n === 2){
      // paneli kapat
      if(textPanel) textPanel.style.display = "none";

      // class'ı kaldır
      root.classList.remove("bp-textmode");

      // text-base placeholder varsa temizle
      state.textBase = null;

      // text input boşalsın (istersen bunu kaldırabiliriz)
      if(textInput) textInput.value = "";

      // patch base görselini tekrar upload frame'e çek
      if(patchBaseEl) patchBaseEl.src = PATCH_FRAME_URL;
    }
    state.step=n;
    panels.forEach(p=>p.classList.toggle("is-active",Number(p.dataset.panel)===n));
    steps.forEach(s=>s.classList.toggle("is-active",Number(s.dataset.step)===n));
  }

  // Design ürününün variant + fiyatını ürün .js endpointinden alır
  async function fetchDesignProduct(){
    try{
      const res=await fetch(`/products/${DESIGN_PRODUCT_HANDLE}.js`,{headers:{Accept:"application/json"}});
      if(!res.ok) throw new Error("design product fetch failed");
      const data=await res.json();
      const v=(data.variants||[]).find(x=>x.available)||(data.variants||[])[0];
      if(v&&v.id){
        state.designVariantId=Number(v.id);
        state.designPriceCents=Number(v.price||900);
      }
    }catch(e){
      state.designPriceCents=900;
    }finally{
      update();
      saveState();
    }
  }

  function updateDesignButtons(){
    const hasDesign=!!(state.design&&state.design.image);
    if(designRemoveBtn) designRemoveBtn.style.display=hasDesign?"":"none";
    if(designBackOldBtn) designBackOldBtn.style.display=(state.oldPatch&&state.oldPatch.variant)?"":"none";
  }

  // Step 3’teki boş patch alanına design preview uygular
  function applyDesignPreviewToEmptyPatch(){
    const hasDesign=!!(state.design&&state.design.image);

    if(designImgEl){
      if(hasDesign){
        designImgEl.src=state.design.image;
      }else{
        designImgEl.removeAttribute("src");
        designImgEl.style.transform="";
      }
    }

    if(designMaskEl) designMaskEl.style.display=hasDesign?"block":"none";
    if(designPlaceholderEl) designPlaceholderEl.style.display=hasDesign?"none":"block";

    // ✅ Add text ayrı dünya: text modunda yazı base'in üstünde görünsün
const isTextMode = !!(state.design && state.design.type === "text") || (textPanel && textPanel.style.display !== "none");
root.classList.toggle("bp-textmode", isTextMode);


    showControls(hasDesign);

    // Text patch ise base görselini seçilen renge göre değiştirir
    if(patchBaseEl){
      if(state.design && state.design.type==="text"){
        patchBaseEl.src = state.design.patchBaseUrl || TEXT_PATCH_BASES[state.textPatchColor] || patchBaseEl.src;
      }
    }

    if(hasDesign){
      ensureTransform();
      applyTransformToImage();
    }

    updateDesignButtons();
  }

  // Patch seçiliyse design moduna geçerken patch’i “oldPatch” olarak saklar
  function activateDesignMode(){
    if(state.patch){
      state.oldPatch={...state.patch};
      state.patch=null;
      root.querySelectorAll('.bp-card[data-type="patch"]').forEach(c=>c.classList.remove("is-selected"));
    }
    updateDesignButtons();
    update();
  }

  // Modal aç/kapat (büyük preview)
  function openModal(){
  if(!modalEl||!modalPreviewEl||!state.beanie) return;

  const beanieImg = state.beanie.image || "";

  // Upload design mi? (sadece upload'ta frame ayrı büyüsün)
  const isUploadDesign = !!(state.design && state.design.type === "image" && state.design.image);

  const isTextDesign = !!(state.design && state.design.type === "text" && state.design.image);
    // ✅ Modal, builder dışında olduğu için text-mode class'ını modala ayrıca basıyoruz
  if (modalEl) {
    const textModeActive = isTextDesign || !!(state.textBase && state.textBase.baseUrl);
    modalEl.classList.toggle("is-textmode", textModeActive);
  }

// TEXT mode base (black/white/brown)
const overlayBase = isTextDesign ? (state.design.patchBaseUrl || "") : "";

// Patch overlay (upload preview / text image / normal patch)
const overlayImg = isUploadDesign
  ? (state.design && state.design.preview ? state.design.preview : "")
  : isTextDesign
    ? (state.design.preview || state.design.image || "")
    : (state.design && (state.design.preview || state.design.image)) ? (state.design.preview || state.design.image)
    : (state.patch && (state.patch.cleanImage || state.patch.image)) ? (state.patch.cleanImage || state.patch.image)
    : (state.textBase && state.textBase.baseUrl) ? state.textBase.baseUrl
    : "";


  // Frame sadece upload design’da ayrı katman
  const frameImg = isUploadDesign ? (PATCH_FRAME_URL || "") : "";

  modalPreviewEl.innerHTML =
    `<div class="bp-preview bp-preview--big">
      ${beanieImg ? `<img class="bp-preview-beanie" src="${escapeHtml(beanieImg)}" alt="${escapeHtml(state.beanie.title)}">` : ""}

      ${overlayBase ? `<img class="bp-preview-patch bp-preview-patch--base" src="${escapeHtml(overlayBase)}" alt="Patch base">` : ""}
${overlayImg ? `<img class="bp-preview-patch ${isTextDesign ? "bp-preview-patch--text" : ""}" src="${escapeHtml(overlayImg)}" alt="Selected patch">` : ""}


      ${frameImg ? `<img class="bp-preview-frame" src="${escapeHtml(frameImg)}" alt="Patch frame">` : ""}
    </div>`;

  modalEl.classList.add("is-open");
  modalEl.setAttribute("aria-hidden","false");
}
  function closeModal(){
    if(!modalEl) return;
    modalEl.classList.remove("is-open");
    modalEl.setAttribute("aria-hidden","true");
    if(modalPreviewEl) modalPreviewEl.innerHTML="";
  }
  if(modalEl){
    modalEl.addEventListener("click",e=>{
      if(e.target.closest("[data-bp-modal-close]")) closeModal();
    });
  }
  document.addEventListener("keydown",e=>{
    if(e.key==="Escape") closeModal();
  });

  // Patch görsellerinde beyaz arka planı saydamlaştırıp trimler
  async function makePatchTransparentAndTrim(url){
    return new Promise(resolve=>{
      const img=new Image();
      img.crossOrigin="anonymous";
      img.onload=()=>{
        try{
          const c=document.createElement("canvas");
          const ctx=c.getContext("2d",{willReadFrequently:true});
          c.width=img.naturalWidth; c.height=img.naturalHeight;
          ctx.drawImage(img,0,0);
          const imgData=ctx.getImageData(0,0,c.width,c.height);
          removeEdgeConnectedWhite(imgData,c.width,c.height,{t:245,tol:18,maxPixels:2500000});
          ctx.putImageData(imgData,0,0);
          const trimmed=trimCanvas(c);
          resolve(trimmed.toDataURL("image/png"));
        }catch(e){
          resolve(url);
        }
      };
      img.onerror=()=>resolve(url);
      img.src=url;
    });
  }
  function removeEdgeConnectedWhite(imgData,w,h,opt){
    const data=imgData.data,t=opt?.t??245,tol=opt?.tol??18,maxPixels=opt?.maxPixels??w*h;
    const visited=new Uint8Array(w*h);
    const qMax=Math.min(w*h,maxPixels);
    const q=new Int32Array(qMax);
    let qh=0,qt=0;

    function isBg(px){
      const i=px*4,a=data[i+3];
      if(a===0) return false;
      const r=data[i],g=data[i+1],b=data[i+2];
      if(r>=t&&g>=t&&b>=t) return true;
      const dr=255-r,dg=255-g,db=255-b;
      return dr<=tol&&dg<=tol&&db<=tol;
    }
    function push(px){
      if(px<0||px>=w*h) return;
      if(visited[px]) return;
      visited[px]=1;
      if(!isBg(px)) return;
      if(qt<q.length) q[qt++]=px;
    }
    for(let x=0;x<w;x++){push(x);push((h-1)*w+x);}
    for(let y=0;y<h;y++){push(y*w);push(y*w+(w-1));}
    let processed=0;
    while(qh<qt){
      const px=q[qh++]; processed++;
      if(processed>maxPixels) break;
      const i=px*4;
      data[i+3]=0;
      const x=px%w,y=px/w|0;
      if(x>0) push(px-1);
      if(x<w-1) push(px+1);
      if(y>0) push(px-w);
      if(y<h-1) push(px+w);
      if(x>0&&y>0) push(px-w-1);
      if(x<w-1&&y>0) push(px-w+1);
      if(x>0&&y<h-1) push(px+w-1);
      if(x<w-1&&y<h-1) push(px+w+1);
    }
  }
  function trimCanvas(canvas){
    const ctx=canvas.getContext("2d",{willReadFrequently:true});
    const {width,height}=canvas;
    const data=ctx.getImageData(0,0,width,height).data;
    let top=height,left=width,right=0,bottom=0;
    for(let y=0;y<height;y++){
      for(let x=0;x<width;x++){
        const a=data[(y*width+x)*4+3];
        if(a>0){
          if(x<left) left=x;
          if(x>right) right=x;
          if(y<top) top=y;
          if(y>bottom) bottom=y;
        }
      }
    }
    if(right===0&&bottom===0&&left===width&&top===height) return canvas;
    const w=right-left+1,h=bottom-top+1;
    const out=document.createElement("canvas");
    out.width=w; out.height=h;
    out.getContext("2d").drawImage(canvas,left,top,w,h,0,0,w,h);
    return out;
  }

  // Sepette seçilenleri render eder
  function renderPicked(slotEl,item,mode){
    if(!slotEl) return;

    if(mode==="patch"){
      const showingDesign=!!(state.design&&state.design.image);
      const patchItem=showingDesign?state.design:state.patch;

      if(patchLabelEl) patchLabelEl.textContent=showingDesign?"Design patch":"Patch";

      // ✅ TEXT MODE: yazı yokken bile base görünsün (Design patch slot)
// ⚠️ Ama beanie seçili değilse asla göstermeyelim (Clear sonrası kalmasın)
if(!patchItem){

  // Beanie yoksa: kesin Not selected
  if(!state.beanie){
    if(patchLabelEl) patchLabelEl.textContent="Patch";
    slotEl.innerHTML = `<span class="bp-muted">Not selected</span>`;
    return;
  }

  // Beanie var + textBase varsa: göster
  if(state.textBase && state.textBase.baseUrl){
    if(patchLabelEl) patchLabelEl.textContent="Design patch";

    slotEl.innerHTML=
      `<div class="bp-picked-row">
        <span class="bp-picked-thumb">
          <img class="bp-picked-base" src="${escapeHtml(state.textBase.baseUrl)}" alt="Patch base">
        </span>
        <div class="bp-picked-namewrap">
          <div class="bp-picked-name">Design Patch</div>
          <div class="bp-picked-price">£0</div>
        </div>
      </div>`;
    return;
  }

  slotEl.innerHTML=`<span class="bp-muted">Not selected</span>`;
  return;
}


      
     // ✅ Design (upload) ise sepette SADECE preview göster (ham foto yok)
if (showingDesign) {
  if (!patchItem.preview) {
    slotEl.innerHTML = `<span class="bp-muted">Preparing preview…</span>`;
    return;
  }
}

const isTextDesign = !!(showingDesign && patchItem.type === "text");
const baseUrlForText = isTextDesign ? (patchItem.patchBaseUrl || "") : "";

// Upload design ise thumb = preview (mask’li) kalsın
const thumb = showingDesign
  ? patchItem.preview
  : (patchItem.image || "");

// Frame sadece upload design’da ayrı katman
const frameUrl = showingDesign
  ? (patchItem.type === "image" ? (PATCH_FRAME_URL || "") : "")
  : "";

// ✅ Patch thumb: TEXT mode = base + text; Upload = preview + frame; Normal patch = image
const leftVisual = isTextDesign
  ? `<span class="bp-picked-thumb">
      ${baseUrlForText ? `<img class="bp-picked-base" src="${escapeHtml(baseUrlForText)}" alt="Patch base">` : ""}
      ${thumb ? `<img class="bp-picked-text" src="${escapeHtml(thumb)}" alt="Text">` : ""}
    </span>`
  : (thumb
      ? `<span class="bp-picked-thumb">
          <img class="bp-picked-img" src="${escapeHtml(thumb)}" alt="${escapeHtml(patchItem.title||"Patch")}">
          ${frameUrl ? `<img class="bp-picked-frame" src="${escapeHtml(frameUrl)}" alt="">` : ""}
        </span>`
      : `<span class="bp-picked-thumb"><div class="bp-picked-img"></div></span>`);


      let priceHtml="";
      if(showingDesign){
        priceHtml=`<div class="bp-picked-price">${formatMoney(Number(state.designPriceCents||900))}</div>`;
      }else{
        priceHtml = state.beanie
          ? `<div class="bp-picked-price"><s>${formatMoney(patchItem.price)}</s><span style="margin-left:6px;">£0</span></div>`
          : `<div class="bp-picked-price">${formatMoney(patchItem.price)}</div>`;
      }

      slotEl.innerHTML=
        `<div class="bp-picked-row">
          ${leftVisual}
          <div class="bp-picked-namewrap">
            <div class="bp-picked-name">${escapeHtml(patchItem.title||(showingDesign?"Design Patch":"Patch"))}</div>
            ${priceHtml}
          </div>
        </div>`;
      return;
    }

    if(!item){
      slotEl.innerHTML=`<span class="bp-muted">Not selected</span>`;
      return;
    }

        const beanieImg = item.image || "";

const isUploadDesign = !!(state.design && state.design.type === "image" && state.design.image);
const isTextDesign   = !!(state.design && state.design.type === "text"  && state.design.image);

let overlayBase = "";
let overlayImg  = "";
let overlayText = "";
let overlayFrame = "";

// TEXT mode: base + text
if (isTextDesign) {
  overlayBase = state.design.patchBaseUrl || "";
  overlayText = state.design.preview || state.design.image || "";
} else if (state.textBase && state.textBase.baseUrl) {
  // yazı yokken sadece base seçilmişse
  overlayBase = state.textBase.baseUrl;
}

// UPLOAD mode: preview + frame
if (isUploadDesign) {
  overlayImg = (state.design && state.design.preview) ? state.design.preview : "";
  overlayFrame = overlayImg ? (PATCH_FRAME_URL || "") : "";
} else if (!isTextDesign) {
  // Normal patch seçimi
  if (state.patch) {
    overlayImg = state.patch.cleanImage || state.patch.image || "";
  } else if (overlayBase) {
    // base’i tek katman gibi göster (duplicate olmasın)
    overlayImg = overlayBase;
    overlayBase = "";
  }
}

slotEl.innerHTML =
  `<div class="bp-picked-row">
    <div class="bp-preview" data-open-preview>
      ${beanieImg ? `<img class="bp-preview-beanie" src="${escapeHtml(beanieImg)}" alt="${escapeHtml(item.title)}">` : ""}

      ${overlayBase ? `<img class="bp-preview-patch bp-preview-patch--base" src="${escapeHtml(overlayBase)}" alt="Patch base">` : ""}

      ${overlayImg ? `<img class="bp-preview-patch" src="${escapeHtml(overlayImg)}" alt="Selected patch">` : ""}

      ${overlayText ? `<img class="bp-preview-patch bp-preview-patch--text" src="${escapeHtml(overlayText)}" alt="Text">` : ""}

      ${overlayFrame ? `<img class="bp-preview-frame" src="${escapeHtml(overlayFrame)}" alt="">` : ""}
    </div>

    <div class="bp-picked-namewrap">
      <div class="bp-picked-name">${escapeHtml(item.title)}</div>
      <div class="bp-picked-price">${formatMoney(item.price)}</div>
    </div>
  </div>`;


  }

  function update(){
    const hasDesign=!!(state.design&&state.design.image);
    const hasPatch=!!state.patch;

    if(countBeanie) countBeanie.textContent=state.beanie?"1":"0";
    if(countPatch) countPatch.textContent=(hasPatch||hasDesign)?"1":"0";
    if(countDesign) countDesign.textContent=hasDesign?"1":"0";

    renderPicked(pickedBeanie,state.beanie,"beanie");
    renderPicked(pickedPatch,state.patch,"patch");

    if(addBtn) addBtn.disabled=!(state.beanie&&(hasPatch || (hasDesign && state.designVariantId>0)));

    applyDesignPreviewToEmptyPatch();
  }

  // Patch kategori filtresi
  function applyPatchFilter(val){
    const v=val||"__all__";
    root.querySelectorAll('.bp-card[data-type="patch"]').forEach(card=>{
      const cat=(card.dataset.category||"").trim();
      card.style.display=(v==="__all__"||cat===v)?"":"none";
    });
  }

  // LocalStorage kaydet
  function saveState(){
    try{
      localStorage.setItem(STORAGE_KEY,JSON.stringify({
        beanie:state.beanie,
        patch:state.patch,
        design:state.design,
        oldPatch:state.oldPatch,
        step:state.step,
        patchCategory:patchCategorySelect?patchCategorySelect.value:"__all__",
        designVariantId:state.designVariantId,
        designPriceCents:state.designPriceCents,
        textPatchColor:state.textPatchColor
      }));
    }catch(e){}
  }

  // LocalStorage restore (UI her zaman step 1’e döner)
  function restoreState(){
  try{
    const raw = localStorage.getItem(STORAGE_KEY);
    if(!raw){
      setStep(1);
      scrollToTop();
      return;
    }
    const data = JSON.parse(raw);

      if(patchCategorySelect&&data.patchCategory) patchCategorySelect.value=data.patchCategory;
      if(typeof data.designVariantId==="number") state.designVariantId=data.designVariantId;
      if(typeof data.designPriceCents==="number") state.designPriceCents=data.designPriceCents;
      if(data.textPatchColor) state.textPatchColor=data.textPatchColor;

      if(data.beanie&&data.beanie.variant){
        state.beanie=data.beanie;
        const el=root.querySelector(`.bp-card[data-type="beanie"][data-variant="${data.beanie.variant}"]`);
        if(el) el.classList.add("is-selected");
      }
      if(data.patch&&data.patch.variant){
        state.patch=data.patch;
        const el=root.querySelector(`.bp-card[data-type="patch"][data-variant="${data.patch.variant}"]`);
        if(el) el.classList.add("is-selected");
      }
      if(data.design&&data.design.image) state.design=data.design;
      if(data.oldPatch&&data.oldPatch.variant) state.oldPatch=data.oldPatch;

      applyPatchFilter(patchCategorySelect?patchCategorySelect.value:"__all__");
      update();
if (isMobile()) {
  const hasAnything = !!(state.beanie && (state.patch || (state.design && state.design.image)));
  root.classList.toggle("bp-show-basket", hasAnything);
}
      if(state.beanie) applyTuningForBeanieTitle(state.beanie.title);
      if(state.design&&state.design.image) refreshPreviewSoon();

      setStep(1);
      scrollToTop();
      if (isMobile()) setTimeout(()=>window.scrollTo(0,0), 0);
    }catch(e){
      setStep(1);
      scrollToTop();
      if (isMobile()) setTimeout(()=>window.scrollTo(0,0), 0);
    }
  }

  // Temizle
  function clearAll(){
    state.beanie=null;
    state.patch=null;
    state.design=null;
    state.oldPatch=null;
    state.textPatchColor="black";
      // ✅ UI reset (ilk giriş gibi)
  state.textBase = null;

  // Text panel kapat + input temizle
  if(textPanel) textPanel.style.display = "none";
  if(textInput) textInput.value = "";

  // Upload input temizle
  if(designFileInput) designFileInput.value = "";

  // Step 3 patch base'i default frame’e dönsün
  if(patchBaseEl) patchBaseEl.src = PATCH_FRAME_URL;

  // Textmode class temizle
  root.classList.remove("bp-textmode");

  // Modal açıksa kapat
  closeModal();

    root.classList.remove("bp-show-basket");
    root.querySelectorAll(".bp-card").forEach(c=>c.classList.remove("is-selected"));

    if(patchCategorySelect) patchCategorySelect.value="__all__";
    applyPatchFilter("__all__");

    setStep(1);
    note("",false);
  update();
  saveState();
    try{ localStorage.removeItem(STORAGE_KEY); }catch(e){}
    if(isMobile()) scrollToTop();
  }
function resetTextMode(){
  // Text temizle
  if(textInput) textInput.value = "";

  state.design = null;
  state.textBase = null;

  if(textPanel) textPanel.style.display = "none";

  // Upload input temizlemesin burada
  update();
  saveState();
}

function resetUploadMode(){
  // Upload temizle
  if(designFileInput) designFileInput.value = "";

  state.design = null;
  state.textBase = null;

  update();
  saveState();
}
  // Beanie search
  root.addEventListener("input",e=>{
    const input=e.target.closest("[data-search]");
    if(!input) return;
    const q=(input.value||"").trim().toLowerCase();
    root.querySelectorAll('.bp-card[data-type="beanie"]').forEach(card=>{
      const t=(card.dataset.title||"").toLowerCase();
      card.style.display=t.includes(q)?"":"none";
    });
  });

  if(patchCategorySelect){
    patchCategorySelect.addEventListener("change",()=>{
      applyPatchFilter(patchCategorySelect.value||"__all__");
      saveState();
    });
  }

  // Move + Zoom (oklar + +/-)
  root.addEventListener("click",e=>{
    const mv=e.target.closest("[data-move]");
    if(mv && state.design && state.design.image){
      ensureTransform();
      const dir=mv.getAttribute("data-move");
      if(dir==="up") state.design.transform.y-=MOVE_STEP;
      if(dir==="down") state.design.transform.y+=MOVE_STEP;
      if(dir==="left") state.design.transform.x-=MOVE_STEP;
      if(dir==="right") state.design.transform.x+=MOVE_STEP;
      if(dir==="center"){ state.design.transform.x=0; state.design.transform.y=0; }
      applyTransformToImage();
      refreshPreviewSoon();
      saveState();
      return;
    }

    const z=e.target.closest("[data-zoom]");
    if(z && state.design && state.design.image){
      ensureTransform();
      const dir=z.getAttribute("data-zoom");
      let s=state.design.transform.scale;
      if(dir==="in") s+=ZOOM_STEP;
      if(dir==="out") s-=ZOOM_STEP;
      s=clamp(s,ZOOM_MIN,ZOOM_MAX);
      state.design.transform.scale=s;
      if(zoomRangeEl) zoomRangeEl.value=String(s);
      applyTransformToImage();
      refreshPreviewSoon();
      saveState();
      return;
    }
  });

  // Slider zoom
  // Slider zoom (drag fix)
if (zoomRangeEl) {
  const syncZoomFromRange = () => {
    if (!(state.design && state.design.image)) return;
    ensureTransform();
    const v = parseFloat(zoomRangeEl.value);
    if (!Number.isFinite(v)) return;
    state.design.transform.scale = clamp(v, ZOOM_MIN, ZOOM_MAX);
    applyTransformToImage();
    refreshPreviewSoon();
    saveState();
  };

  // Drag sırasında kesin çalışsın
  ["input", "change", "pointermove", "touchmove", "mousemove"].forEach(ev => {
    zoomRangeEl.addEventListener(ev, syncZoomFromRange, { passive: true });
  });

  // Root click handler vs. çakışmasın
  ["pointerdown", "touchstart", "mousedown"].forEach(ev => {
    zoomRangeEl.addEventListener(ev, (e) => e.stopPropagation(), { passive: true });
  });
}
if (zoomRangeEl) {
  zoomRangeEl.addEventListener("change", () => {
    if (!(state.design && state.design.image)) return;
    ensureTransform();
    state.design.transform.scale = clamp(
      parseFloat(zoomRangeEl.value || "1"),
      ZOOM_MIN,
      ZOOM_MAX
    );
    applyTransformToImage();
    refreshPreviewSoon();
    saveState();
  });
}
 // Upload butonu (Choose file) -> her zaman upload moduna dön
if(designUploadBtn && designFileInput){
  designUploadBtn.addEventListener("click",()=>{
  resetTextMode();
  activateDesignMode(); // ✅ Choose a patch seçimini sıfırla
  if(!state.beanie){
      note("Please select a beanie first.",true);
      setStep(1);
      return;
    }

    // ✅ Add text panelini kapat (ayrı dünya)
    if(textPanel) textPanel.style.display = "none";

    // ✅ Patch base'i her zaman "Choose file" frame'e geri döndür
    if(patchBaseEl){
      patchBaseEl.src = PATCH_FRAME_URL;
    }

    // ✅ Step 3'te kal
    setStep(3);

    // Dosya seçtir
    designFileInput.click();
  });
}

  // Upload seçilince design state oluşturur
  if(designFileInput){
    designFileInput.addEventListener("change",async()=>{
      const file=designFileInput.files&&designFileInput.files[0];
      if(!file) return;

      activateDesignMode();
      setStep(3);

      const reader=new FileReader();
      reader.onload=async()=>{
        const dataUrl=String(reader.result||"");
        if(!dataUrl) return;

        state.design = {
  type: "image",
  title: "Design Patch",
  image: dataUrl,
  preview: "",
  price: Number(state.designPriceCents || 900),
  fileName: file.name || "",
  variant: Number(state.designVariantId || 0),

  // ✅ Siyah patch frame (basket + modal + preview için)
  patchBaseUrl: PATCH_FRAME_URL,

  transform: { x: 0, y: 0, scale: 1.15 }
};

        const mask=document.querySelector("[data-design-mask]");
        if(mask){
          const r=mask.getBoundingClientRect();
          state.design.transform.baseW=r.width||240;
          state.design.transform.baseH=r.height||240;
        }else{
          state.design.transform.baseW=240;
          state.design.transform.baseH=240;
        }

        update();       // basket: "Preparing preview…"
saveState();

await buildAndSetDesignPreview(); // ✅ frame + mask + zoom PNG üret
update();
saveState();

if(isMobile() && state.beanie){
  root.classList.add("bp-show-basket");
}
      };
      reader.readAsDataURL(file);
    });
  }

  // Design sil
  if(designRemoveBtn){
    designRemoveBtn.addEventListener("click",()=>{
      state.design=null;
      if(designFileInput) designFileInput.value="";
      update();
      saveState();
    });
  }

  // Eski patch’e dön
  if(designBackOldBtn){
    designBackOldBtn.addEventListener("click",async()=>{
      if(!state.oldPatch) return;
      state.patch={...state.oldPatch};
      state.oldPatch=null;
      state.design=null;
      if(designFileInput) designFileInput.value="";
      update();
      saveState();
      setStep(2);
    });
  }

  // Text panel aç/kapa
if(textBtn && textPanel){
  textBtn.addEventListener("click",()=>{
  resetUploadMode();
  activateDesignMode(); // ✅ Choose a patch seçimini sıfırla
  if(!state.beanie){
      note("Please select a beanie first.",true);
      setStep(1);
      return;
    }

    const willOpen = (textPanel.style.display === "none");
    textPanel.style.display = willOpen ? "" : "none";
    setStep(3);

    // ✅ Panel açılıyorsa: default black base hemen gelsin
    if(willOpen){
      state.textPatchColor = state.textPatchColor || "black";

      // UI aktif buton
      patchColorBtns.forEach(b=>{
        b.classList.toggle("is-active", (b.getAttribute("data-patch-color")||"") === state.textPatchColor);
      });

      // Base görsel
      if(patchBaseEl && TEXT_PATCH_BASES[state.textPatchColor]){
        patchBaseEl.src = TEXT_PATCH_BASES[state.textPatchColor];
      }
    }

    saveState();
  });
}

  // Text UI toggles
  if(textBoldBtn){
    textBoldBtn.addEventListener("click",()=>{
      textUi.bold=!textUi.bold;
      textBoldBtn.classList.toggle("is-active",textUi.bold);
      applyLiveText();
    });
  }
  if(textItalicBtn){
    textItalicBtn.addEventListener("click",()=>{
      textUi.italic=!textUi.italic;
      textItalicBtn.classList.toggle("is-active",textUi.italic);
      applyLiveText();
    });
  }
  if(textUpperToggle){
    textUpperToggle.addEventListener("click",()=>{
      textUi.upper=!textUi.upper;
      textUpperToggle.classList.toggle("is-active",textUi.upper);
      applyLiveText();
    });
  }
  if(textStrokeToggle){
    textStrokeToggle.addEventListener("click",()=>{
      textUi.stroke=!textUi.stroke;
      textStrokeToggle.classList.toggle("is-active",textUi.stroke);
      applyLiveText();
    });
  }
  if(textShadowToggle){
    textShadowToggle.addEventListener("click",()=>{
      textUi.shadow=!textUi.shadow;
      textShadowToggle.classList.toggle("is-active",textUi.shadow);
      applyLiveText();
    });
  }

  textAlignBtns.forEach(b=>b.addEventListener("click",()=>{
    setAlignUI(b.getAttribute("data-talign")||"center");
    applyLiveText();
  }));
  setAlignUI("center");

  // Text input live
  if(textInput){
    textInput.addEventListener("input",()=>{
      note("",false);
      applyLiveText();
    });
  }
  [textSize,textColor,textFont,textLetter,textLine,textStrokeWidth].forEach(el=>{
    if(!el) return;
    el.addEventListener("input",()=>{ applyLiveText(); });
  });

  // Patch color seçimi (text için base değiştirir)
 patchColorBtns.forEach(btn=>{
  btn.addEventListener("click",()=>{
    patchColorBtns.forEach(b=>b.classList.remove("is-active"));
    btn.classList.add("is-active");

    const c = btn.getAttribute("data-patch-color") || "black";
    state.textPatchColor = c;
    // ✅ Otomatik yazı rengi ayarı
if (textColor) {
  if (c === "white") {
    textColor.value = "#111111";
  } else {
    textColor.value = "#ffffff";
  }
}

    const baseUrl = TEXT_PATCH_BASES[state.textPatchColor] || "";

    // ✅ Add Text base görselini değiştir
    if(patchBaseEl && baseUrl){
      patchBaseEl.src = baseUrl;
    }

    // ✅ Yazı yokken bile basket + beanie preview üstünde gözüksün
    // (sadece base, henüz design yok)
    const hasTypedText = !!String(textInput?.value || "").trim();
    if(!hasTypedText){
      state.textBase = { title:"Design Patch", baseUrl };
      update();
    }

    // Yazı varsa zaten applyLiveText design üretir
    applyLiveText();
    saveState();

    if(isMobile() && state.beanie){
      root.classList.add("bp-show-basket");
    }
  });
});

  // Clear text
  if(textCancel){
    textCancel.addEventListener("click",()=>{
      if(textInput) textInput.value="";
      state.design=null;
      update();
      saveState();
    });
  }

  // Text’i design’e çevirir
  async function applyLiveText(){
    const txt=String(textInput?.value||"").trim();
    if(!txt){
      if(state.design && state.design.type==="text"){
        state.design=null;
        update();
        saveState();
      }
      return;
    }

    activateDesignMode();
    setStep(3);

    const props={
      text:txt,
      size:Number(textSize?.value||48),
      color:String(textColor?.value||"#111111"),
      bold:!!textUi.bold,
      italic:!!textUi.italic,
      align:textUi.align||"center",
      font:String(textFont?.value||"Arial"),
      letter:Number(textLetter?.value||0),
      line:Number(textLine?.value||1.15),
      upper:!!textUi.upper,
      stroke:!!textUi.stroke,
      strokeW:Number(textStrokeWidth?.value||3),
      shadow:!!textUi.shadow
    };

    const textImg=makeTextImageDataUrl(props);
state.textBase = null; // ✅ artık gerçek text design var, base-only gerekmiyor
// ✅ Patch base'i her zaman "Choose file" frame'e geri döndür
if(patchBaseEl){
  patchBaseEl.src = PATCH_FRAME_URL;
}
    state.design={
      type:"text",
      title:"Design Patch",
      image:textImg,
      preview:"",
      price:Number(state.designPriceCents||900),
      fileName:"text",
      variant:Number(state.designVariantId||0),
      textProps:props,
      patchBaseUrl: TEXT_PATCH_BASES[state.textPatchColor] || "",
      patchColor: state.textPatchColor,
      transform:{x:0,y:0,scale:1.15}
    };

    const mask=document.querySelector("[data-design-mask]");
    if(mask){
      const r=mask.getBoundingClientRect();
      state.design.transform.baseW=r.width||240;
      state.design.transform.baseH=r.height||240;
    }else{
      state.design.transform.baseW=240;
      state.design.transform.baseH=240;
    }

    update();
await buildAndSetDesignPreview();  // ✅ text için de crop+zoom preview üret
update();
saveState();

if(isMobile() && state.beanie){
  root.classList.add("bp-show-basket");
  // ✅ Text yazarken asla otomatik scroll yapma
}
  }

  // Ana click handler: step, kart seçimi, back, clear, add to cart
  root.addEventListener("click",async e=>{
    if(e.target.closest("[data-open-preview]")){
      openModal();
      return;
    }

    if(e.target.closest("[data-back-to-patches]")){
      setStep(2);
      saveState();
      scrollToTop();
      return;
    }

    const stepBtn=e.target.closest(".bp-step");
    if(stepBtn){
      const n=Number(stepBtn.dataset.step);
      if(n===3&&!state.beanie){
        note("Please select a beanie first.",true);
        setStep(1);
        return;
      }
      setStep(n);
      update();
      saveState();
      return;
    }

    const card=e.target.closest(".bp-card");
    if(card && root.contains(card)){
      const type=card.dataset.type;

      root.querySelectorAll(`.bp-card[data-type="${type}"]`).forEach(c=>c.classList.remove("is-selected"));
      card.classList.add("is-selected");

      const realImg=card.querySelector("img")?card.querySelector("img").getAttribute("src"):"";
      const safeImg=realImg||card.dataset.image||"";

      state[type]={
        variant:Number(card.dataset.variant),
        title:card.dataset.title||"",
        image:safeImg,
        price:Number(card.dataset.price||0)
      };

      note("",false);

      if(type==="beanie"){
        setStep(2);
        applyTuningForBeanieTitle(state.beanie.title);
        update();
      }

      if(type==="patch" && state.patch && state.patch.image){
        state.design=null;
        if(designFileInput) designFileInput.value="";
        state.patch.cleanImage=await makePatchTransparentAndTrim(state.patch.image);
        update();
      }

      if(type==="patch" && state.beanie && isMobile()){
        root.classList.add("bp-show-basket");
        setTimeout(scrollToBasketWithOffset,80);
      }

      saveState();
      return;
    }

    if(e.target.closest(".bp-back")){
      if(e.target.closest(".bp-back--to-patches")) return;
      root.classList.remove("bp-show-basket");
      setStep(1);
      saveState();
      scrollToTop();
      return;
    }

    if(e.target.closest(".bp-clear")){
      clearAll();
      return;
    }

    if(e.target.closest(".bp-add")){
      const hasDesign=!!(state.design&&state.design.image);
      const hasPatch=!!state.patch;
      if(!state.beanie || !(hasPatch||hasDesign)) return;

      if(hasDesign && state.designVariantId<=0){
        note("Design patch product could not be loaded. Please refresh and try again.",true);
        return;
      }

      addBtn.disabled=true;
      note("Adding to cart…",true);

      try{
        const items=[];
        items.push({id:state.beanie.variant,quantity:1});

        if(hasPatch){
          items.push({id:state.patch.variant,quantity:1});
        }else if(hasDesign){
          ensureTransform();

          if(!(state.design.transform.baseW&&state.design.transform.baseH)){
            const mask=document.querySelector("[data-design-mask]");
            if(mask){
              const r=mask.getBoundingClientRect();
              state.design.transform.baseW=r.width||240;
              state.design.transform.baseH=r.height||240;
            }else{
              state.design.transform.baseW=240;
              state.design.transform.baseH=240;
            }
          }

          note("Preparing your print…",true);
          const blob=await generateFinalPrintPngBlob();

          note("Uploading your design…",true);
          const cloudUrl=await window.uploadToCloudinary(blob);

          const props={
            "Custom Design":"Yes",
            "Design File URL": cloudUrl
          };
          if(state.design.type==="text"){
            props["Patch Color"] = String(state.textPatchColor||"black");
          }

          items.push({id:Number(state.designVariantId),quantity:1,properties:props});
        }

        const res=await fetch("/cart/add.js",{
          method:"POST",
          headers:{"Content-Type":"application/json","Accept":"application/json"},
          body:JSON.stringify({items})
        });
        if(!res.ok) throw new Error(await res.text());

        note("",false);
        window.location.href="/cart";
      }catch(err){
        console.error(err);
        note("Something went wrong. Please try again.",true);
      }finally{
        addBtn.disabled=!(state.beanie&&(hasPatch||(hasDesign&&state.designVariantId>0)));
      }
    }
  });

  // init
  applyPatchFilter("__all__");
  setStep(1);
  update();
  restoreState();
  fetchDesignProduct();

  if(modalEl){
    modalEl.addEventListener("click",e=>{
      if(e.target.closest("[data-bp-modal-close]")) closeModal();
    });
  }
})();
